import { render, staticRenderFns } from "./VisualizationLegend.vue?vue&type=template&id=05273598&"
import script from "./VisualizationLegend.vue?vue&type=script&lang=js&"
export * from "./VisualizationLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports